// app/providers.tsx
'use client'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PHProvider({
    children,
}: {
    children: React.ReactNode
}) {
    useEffect(() => {
        console.log(process.env.NODE_ENV)
        if (!process.env.NEXT_PUBLIC_POSTHOG_KEY || !process.env.NEXT_PUBLIC_POSTHOG_HOST) {
            console.warn('PostHog environment variables are not set')
            return
        }

        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
            person_profiles: 'identified_only',
            capture_pageview: false,
            loaded: (posthog) => {
                if (process.env.NODE_ENV === 'development') {
                    posthog.opt_out_capturing();
                    posthog.debug()
                }
            }
        })
    }, []);

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}